// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"0c861298","87":"3385448c","146":"295141d6","154":"04d2c142","192":"d858ee44","253":"40c58853","327":"8d924870","492":"e4c59d6b","494":"fe5d28b0","548":"eca41fdd","599":"51f062ba","741":"3bba0031","787":"eab392b5","951":"827e23a3","984":"56d64c06"}[chunkId] + ".chunk.js";
};